import * as Yup from 'yup';
import * as R from './rules';

export const validationSchema = Yup.object({
  name: Yup.string().required('نام شرکت الزامی است'),
  display_name: Yup.string().required('نام نمایشی الزامی است'),
  // These were `^\d{1,11}$` / `^\d{1,10}$`, which accepted a single digit and
  // left the api to reject it after a round trip.
  national_id: Yup.string()
    .required('شناسه ملی الزامی است')
    .matches(R.LEGAL_ID, R.LEGAL_ID_MESSAGE),
  address: Yup.string().required('آدرس الزامی است'),
  postal_code: Yup.string()
    .required('کدپستی الزامی است')
    .matches(R.POSTAL_CODE, R.POSTAL_CODE_MESSAGE),
  phone: Yup.string()
    .required('تلفن ثابت الزامی است')
    .matches(R.LANDLINE_PHONE, R.LANDLINE_PHONE_MESSAGE),
});
